"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entries = void 0;
exports.entries = [
    {
        id: "2156DA4B",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "H518301",
                given_name: null,
                family_name: null
            }
        ],
        note_date: "2023-07-25 00:00:00",
        note_type: null,
        note_specialty: null
    },
    {
        id: "2156DA4D",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "2156DA4D",
            type: "HAR"
        },
        location: {
            service_facility: "HFH",
            department: "1010010174:HFH:HFH EP:CARDIOLOGY",
            point_of_care: "1010010174:HFH:HFH EP:CARDIOLOGY"
        },
        meta: {
            event_datetime: "2023-05-10 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "b65afb1d-e788-5f30-96eb-bbb00ecc02df",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            },
            {
                type: "primaryAthenticator",
                identifier: "2d6abd77-2a1b-5afc-9ef0-5b936b019e91",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            }
        ],
        note_date: "2023-02-10 00:00:00",
        note_type: "Progress Notes",
        note_specialty: null
    },
    {
        id: "2156DA4C",
        message: {
            type: "DFT",
            code: "PO3"
        },
        encounter: {
            identifier: "2156DA4C",
            type: "CSN"
        },
        location: {
            service_facility: null
        },
        meta: {
            event_datetime: "2021-07-02 00:00:00"
        },
        providers: [
            {
                type: "billing",
                identifier: "H1614",
                given_name: null,
                family_name: null,
                provider_specialty: "Neurological Surgery"
            }
        ],
        procedures: ["99202"]
    },
    {
        id: "64F4553C",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "H518301",
                given_name: null,
                family_name: null
            }
        ],
        note_date: "2023-07-25 00:00:00",
        note_type: null,
        note_specialty: null
    },
    {
        id: "FB66AF65",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "H542812",
                given_name: null,
                family_name: null
            }
        ],
        note_date: "2023-07-25 00:00:00",
        note_type: null,
        note_specialty: null
    },
    {
        id: "4A860AD9",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "H542812",
                given_name: null,
                family_name: null
            }
        ],
        note_date: "2023-07-25 00:00:00",
        note_type: null,
        note_specialty: null
    },
    {
        id: "E96BEBCD",
        message: {
            type: "MDM",
            code: "T02"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 00:00:00"
        },
        providers: [
            {
                type: "authoring",
                identifier: "H563676",
                given_name: null,
                family_name: null
            }
        ],
        note_date: "2023-07-25 00:00:00",
        note_type: null,
        note_specialty: null
    },
    {
        id: "03F9EFE9",
        message: {
            type: "ADT",
            code: "A08"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 13:57:41"
        },
        providers: [
            {
                type: "admitting",
                identifier: "b65afb1d-e788-5f30-96eb-bbb00ecc02df",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            },
            {
                type: "attending",
                identifier: "2d6abd77-2a1b-5afc-9ef0-5b936b019e91",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            }
        ],
        hospital_service: "Not assigned.",
        insurances: [
            {
                company_identifier: "3004",
                company_name: ""
            }
        ],
        patient_class: "EMERGENCY"
    },
    {
        id: "DB143201",
        message: {
            type: "ADT",
            code: "A04"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH"
        },
        meta: {
            event_datetime: "2023-07-25 13:57:41"
        },
        providers: [
            {
                type: "admitting",
                identifier: "b65afb1d-e788-5f30-96eb-bbb00ecc02df",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            },
            {
                type: "attending",
                identifier: "2d6abd77-2a1b-5afc-9ef0-5b936b019e91",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            }
        ],
        insurances: [
            {
                company_name: ""
            }
        ],
        patient_class: "EMERGENCY"
    },
    {
        id: "2E69F1F2",
        message: {
            type: "ADT",
            code: "A04"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH"
        },
        meta: {
            event_datetime: "2023-07-25 13:58:33"
        },
        providers: [
            {
                type: "admitting",
                identifier: "b65afb1d-e788-5f30-96eb-bbb00ecc02df",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            },
            {
                type: "attending",
                identifier: "2d6abd77-2a1b-5afc-9ef0-5b936b019e91",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            }
        ],
        insurances: [
            {
                company_identifier: "3004",
                company_name: ""
            }
        ],
        patient_class: "EMERGENCY"
    },
    {
        id: "B5EEEF46",
        message: {
            type: "ADT",
            code: "A08"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 13:58:33"
        },
        providers: [],
        hospital_service: "Emergency Medicine",
        insurances: [
            {
                company_name: ""
            }
        ],
        patient_class: "EMERGENCY"
    },
    {
        id: "8057C6EF",
        message: {
            type: "ADT",
            code: "A08"
        },
        encounter: {
            identifier: "789441446",
            type: "HAR"
        },
        location: {
            service_facility: "HFWH",
            department: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE",
            point_of_care: "1050010020:EWY:WYH ED:EMERGENCY MEDICINE"
        },
        meta: {
            event_datetime: "2023-07-25 13:58:35"
        },
        providers: [
            {
                type: "admitting",
                identifier: "b65afb1d-e788-5f30-96eb-bbb00ecc02df",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            },
            {
                type: "attending",
                identifier: "2d6abd77-2a1b-5afc-9ef0-5b936b019e91",
                given_name: "ADMIN",
                family_name: "AMBULATORY"
            }
        ],
        hospital_service: "Emergency Medicine",
        insurances: [
            {
                company_identifier: "3004",
                company_name: ""
            }
        ],
        patient_class: "EMERGENCY"
    },
    {
        id: "1234567",
        message: {
            type: "RDS",
            code: "O13"
        },
        encounter: {
            identifier: "6786786789",
            type: "HAR"
        },
        location: {
            service_facility: "HFHN HENRY FORD HOSPITAL"
        },
        meta: {
            event_datetime: "2023-08-23 09:46:56"
        },
        providers: [
            {
                type: "medicationOrdering",
                identifier: "M518301",
                given_name: "Medication",
                family_name: "Ordered"
            }
        ],
        medication_administered: "DEXMEDETOMIDINE 1000 MCG/250 ML INFUSION",
        medication_route: "route",
        order_action: "administered"
    }
];
//# sourceMappingURL=entries.js.map